import { withStateHandlers } from 'recompose';

export default withStateHandlers({ selectedFacility: null }, {
	setSelectedFacility: () => (selectedFacility) => ({ selectedFacility }),
	handleMapAndHoursClose: () => () => ({ selectedFacility: null })
});
